const types = require('constants/actionTypes');

const resultSelected = ({ result }) => (dispatch, getState) => dispatch({
    type: types.GLOSSARY_RESULT_SELECTED,
    payload: {
        result,
        originCountry: getState().profile.get('originCountry')
    },
});

module.exports = resultSelected;
